/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Caption_Style_DescInputs */

const en_caption_style_desc = /** @type {(inputs: Caption_Style_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Change caption style of selected events`)
};

const fr_caption_style_desc = /** @type {(inputs: Caption_Style_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Modifier le style des événements sélectionnés`)
};

const de_caption_style_desc = /** @type {(inputs: Caption_Style_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ändern Sie den Untertitelstil der ausgewählten Ereignisse`)
};

const it_caption_style_desc = /** @type {(inputs: Caption_Style_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Cambia lo stile della didascalia degli eventi selezionati`)
};

const ru_caption_style_desc = /** @type {(inputs: Caption_Style_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Изменить стиль подписи к выбранным событиям`)
};

const es_caption_style_desc = /** @type {(inputs: Caption_Style_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Cambiar el estilo de subtítulos de los eventos seleccionados`)
};

const zh_cn2_caption_style_desc = /** @type {(inputs: Caption_Style_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`更改所选事件的标题样式`)
};

const ja_caption_style_desc = /** @type {(inputs: Caption_Style_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`選択したイベントのキャプションスタイルを変更する`)
};

const hi_caption_style_desc = /** @type {(inputs: Caption_Style_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`चयनित इवेंट्स के कैप्शन स्टाइल बदलें`)
};

const pt_pt2_caption_style_desc = /** @type {(inputs: Caption_Style_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Alterar o estilo da legenda dos eventos selecionados`)
};

/**
* | output |
* | --- |
* | "Change caption style of selected events" |
*
* @param {Caption_Style_DescInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const caption_style_desc = /** @type {((inputs?: Caption_Style_DescInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Caption_Style_DescInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_caption_style_desc(inputs)
	if (locale === "de") return de_caption_style_desc(inputs)
	if (locale === "it") return it_caption_style_desc(inputs)
	if (locale === "ru") return ru_caption_style_desc(inputs)
	if (locale === "es") return es_caption_style_desc(inputs)
	if (locale === "zh-CN") return zh_cn2_caption_style_desc(inputs)
	if (locale === "ja") return ja_caption_style_desc(inputs)
	if (locale === "hi") return hi_caption_style_desc(inputs)
	if (locale === "pt-PT") return pt_pt2_caption_style_desc(inputs)
	return en_caption_style_desc(inputs)
});